<template>
<div class="data-list-container">
    <side-view
      :isSidebarActive="isSidebarActive"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
      :gridEfficiencyTemplateId="gridEfficiencyTemplateId"
      @onUpdated="onUpdated"
      @onInserted="onInserted"
    />
    <vs-row>
      <vs-table ref="table" v-model="selected" :data="rates" :noDataText="$t('Decarbonization.GridEfficiency.NoRates')" >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-row vs-type="flex" vs-justify="space-between" class="m-3">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-add"
                @click="addNewData"
              >{{$t('AddNew')}}</vs-button>
            </vs-col>
          </vs-row>
        </div>
        <template slot="thead">
          <vs-th>{{$t('Action')}}</vs-th>
          <vs-th>{{$t('Decarbonization.GridEfficiency.StartYear')}}</vs-th>
          <vs-th>{{$t('Decarbonization.GridEfficiency.EndYear')}}</vs-th>
          <vs-th>{{$t('Decarbonization.GridEfficiency.Rate')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td width="100px" class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editRate(tr)"
                  v-b-tooltip.hover :title="$t('Edit')"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="openDeleteConfirm(tr.id)"
                  v-b-tooltip.hover :title="$t('Delete')"
                />       
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ tr.startYear }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ tr.endYear }}</p>
              </vs-td>
              <vs-td>
                <p class="font-medium">{{ tr.rate }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vs-row>
</div>

</template>

<script>

import sideView from "./sideView.vue";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    sideView
  },
  props: {
    readOnly : {
      type: Boolean,
      default: false
    },
    gridEfficiencyTemplateId : {
      type: Number
    },
    rates: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {      
      selected: [],
      isMounted: false,
      // Data Sidebar
      isSidebarActive: false,
      sidebarData: {}
    };
  },
  created() {
    
  },

  computed: {
  },

  methods: {
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    editRate(model) {
      this.sidebarData = model;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.isSidebarActive = val;
    },
    onUpdated(obj) {
      this.toggleDataSidebar(false);
      this.$emit("onUpdated", obj);
    },
    onInserted(obj) {
      this.$emit("onInserted", obj);
      this.toggleDataSidebar(false);
    },
    openDeleteConfirm(id) {
      this.$deleteConfirmation({
        text: this.$t('Decarbonization.GridEfficiency.ConfirmDelete'),
        accept:  () => this.deleteData(id)
      });
    },
    deleteData(id) {
      this.$emit("onDeleted", id);
    }
  }
};
</script>
